export const normalizeGsm = (gsm) => {
  if (!gsm) return null;
  return gsm
    .replace('+90', '')
    .replaceAll(')', '')
    .replaceAll('(', '')
    .replaceAll('-', '')
    .replaceAll(' ', '');
};